import React from 'react'
import TooltipInputError from '../toolTip/ToolTipInputError'
import { FormControl, TextField } from '@material-ui/core'

function DescriptionField({
   fieldLabel,
   fieldName = 'description',
   formValue,
   fieldInvalid,
   handleChange,
   maxLength,
   rows = 2
}) {
   return (
      <FormControl fullWidth>
         <TextField
            multiline
            minRows={rows}
            error={fieldInvalid}
            value={formValue}
            onChange={handleChange}
            inputProps={{ maxlength: maxLength }}
            InputProps={{
               endAdornment: formValue?.length === maxLength && (
                  <TooltipInputError
                     title={`El número permitido de caracteres es de máximo ${maxLength}.`}
                  />
               )
            }}
            label={fieldLabel}
            name={fieldName}
            helperText={
               fieldInvalid
                  ? formValue === ''
                     ? 'El campo Descripción es obligatorio.'
                     : 'Introduzca una Descripción válida.'
                  : ''
            }
            variant="outlined"
            size="small"
            margin="normal"
         />
      </FormControl>
   )
}

export default DescriptionField
